export interface SpecFieldConfig {
  name: string;
  placeholder: string;
  labelKey?: string;
  unit?: string;
}

export interface SteelSpecConfig {
  fields: SpecFieldConfig[];
  format: (values: string[]) => string;
}

export const steelSpecConfigs: Record<string, SteelSpecConfig> = {
  TUBE: {
    fields: [
      { name: "width", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "height", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "thickness", placeholder: "厚", labelKey: "thickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  BOX: {
    fields: [
      { name: "width", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "height", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "flangeThickness", placeholder: "翼板厚", labelKey: "flangeThickness", unit: "mm" },
      { name: "webThickness", placeholder: "腹板厚", labelKey: "webThickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  H: {
    fields: [
      { name: "H", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "B", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "tw", placeholder: "腹板厚", labelKey: "webThickness", unit: "mm" },
      { name: "tf", placeholder: "翼板厚", labelKey: "flangeThickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  RH: {
    fields: [
      { name: "H", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "B", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "tw", placeholder: "腹板厚", labelKey: "webThickness", unit: "mm" },
      { name: "tf", placeholder: "翼板厚", labelKey: "flangeThickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  BH: {
    fields: [
      { name: "H", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "B", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "tw", placeholder: "腹板厚", labelKey: "webThickness", unit: "mm" },
      { name: "tf", placeholder: "翼板厚", labelKey: "flangeThickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  I: {
    fields: [
      { name: "H", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "B", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "tw", placeholder: "腹板厚", labelKey: "webThickness", unit: "mm" },
      { name: "tf", placeholder: "翼板厚", labelKey: "flangeThickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  L: {
    fields: [
      { name: "A", placeholder: "邊長A", labelKey: "legA", unit: "mm" },
      { name: "B", placeholder: "邊長B", labelKey: "legB", unit: "mm" },
      { name: "t", placeholder: "厚", labelKey: "thickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  U: {
    fields: [
      { name: "H", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "B", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "tw", placeholder: "腹板厚", labelKey: "webThickness", unit: "mm" },
      { name: "tf", placeholder: "翼板厚", labelKey: "flangeThickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  BT: {
    fields: [
      { name: "H", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "B", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "tw", placeholder: "腹板厚", labelKey: "webThickness", unit: "mm" },
      { name: "tf", placeholder: "翼板厚", labelKey: "flangeThickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  CT: {
    fields: [
      { name: "H", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "B", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "tw", placeholder: "腹板厚", labelKey: "webThickness", unit: "mm" },
      { name: "tf", placeholder: "翼板厚", labelKey: "flangeThickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  T: {
    fields: [
      { name: "H", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "B", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "tw", placeholder: "腹板厚", labelKey: "webThickness", unit: "mm" },
      { name: "tf", placeholder: "翼板厚", labelKey: "flangeThickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  C: {
    fields: [
      { name: "H", placeholder: "高", labelKey: "height", unit: "mm" },
      { name: "B", placeholder: "寬", labelKey: "width", unit: "mm" },
      { name: "C", placeholder: "唇邊", labelKey: "lip", unit: "mm" },
      { name: "t", placeholder: "厚", labelKey: "thickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  PIPE: {
    fields: [
      { name: "diameter", placeholder: "外徑", labelKey: "outerDiameter", unit: "mm" },
      { name: "thickness", placeholder: "厚", labelKey: "thickness", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  FB: {
    fields: [
      { name: "thickness", placeholder: "厚", labelKey: "thickness", unit: "mm" },
      { name: "width", placeholder: "寬", labelKey: "width", unit: "mm" },
    ],
    format: (values) => values.join("X"),
  },
  RB: {
    fields: [{ name: "diameter", placeholder: "直徑", labelKey: "diameter", unit: "mm" }],
    format: (values) => values[0] || "",
  },
};

export function parseSpec(steelType: string, spec: string): string[] {
  const config = steelSpecConfigs[steelType];
  if (!config || !spec) return [];
  return spec.split("X");
}

export function formatSpec(steelType: string, values: string[]): string {
  const config = steelSpecConfigs[steelType];
  if (!config) return values.join("X");
  return config.format(values.filter((v) => v !== ""));
}
